<template>
  <el-breadcrumb class="breadcrumb" :class="{ 'breadcrumb-show': levelList.length }" separator="">
    <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
      <div class="breadcrumb-item">
        <span
          v-if="item.redirect === 'noRedirect' || index === levelList.length - 1"
          class="no-redirect"
          >{{ item.meta.title }}</span
        >
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
        <svg-icon v-if="index !== levelList.length - 1" class-name="right-icon" name="right-icon" />
      </div>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script lang="ts">
export default {
  name: 'Breadcrumb'
}
</script>

<script lang="ts" setup>
import { debounce } from 'lodash-es'
import { watch, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

const levelList = ref([] as any[])

function getBreadcrumb() {
  const matched = route.matched.filter((item) => item.meta && item.meta.title)
  if (matched[0]?.meta?.isGroupName) {
    levelList.value = []
    return
  }
  levelList.value = matched.filter((item) => item.meta && item.meta.title)
}

function handleLink(item: any) {
  const { redirect, path } = item
  if (redirect) {
    router.push(redirect)
    return
  }
  router.push(path)
}

watch(() => route.matched, debounce(getBreadcrumb, 100), { immediate: true })
</script>

<style scoped lang="scss">
.breadcrumb {
  height: 20px;
  &.breadcrumb-show {
    height: 50px;
    line-height: 50px;
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;
  }

  :deep(.el-breadcrumb__separator) {
    margin: 0;
  }

  .right-icon {
    width: 8px;
    height: 8px;
    margin: 0 9px;
    color: #666;
  }
}
</style>
